import React, { useMemo } from 'react';

import { ArkOpinion } from '../my-opinions/store';
import { CollateralProviderInstance } from './CollateralProviderInstance';
import { NettingInstance } from './NettingInstance';
import styles from './OpinionInstance.module.scss';
import { RepoInstance } from './RepoInstance';
import { ClientRelianceOpinionInstance, CollateralProviderOpinionInstance, CollateralTakerOpinionInstance, OpinionInstance as Instance, NettingOpinionInstance, OpinionInstanceType, RepoOpinionInstance, RepoStockLendingOpinionInstance, StockLendingOpinionInstance } from './store/types';
import { useFetchStarted } from '../../../hooks/useFetchStarted';
import { fetchAllDropdownListsStarted } from '../../admin/dropdown-lists/store';
import { CollateralTakerInstance } from './CollateralTakerInstance';
import { StockLendingInstance } from './StockLendingInstance';
import { RepoStockLendingInstance } from './RepoStockLendingInstance';
import { useAppSelector } from '../../../hooks/react-redux';
import { getNettingEngineFields, getPreviousInstance } from './store/selectors';
import { ClientRelianceInstance } from './ClientRelianceInstance';

interface OpinionInstanceProps {
    instance: Instance;
    opinion: ArkOpinion;
    isEditing: boolean;
    isUpdating: boolean;
    width: number;
}

export const OpinionInstance: React.FC<OpinionInstanceProps> = ({ isEditing, isUpdating, opinion, instance, width }) => {

    useFetchStarted([fetchAllDropdownListsStarted()]);

    const nettingEngineFields = useAppSelector(getNettingEngineFields);
    const previousInstance = useAppSelector(getPreviousInstance);

    const component = useMemo(() => {
        switch (instance.type) {
            case OpinionInstanceType.NETTING:
                return <NettingInstance
                    instance={instance}
                    previousInstance={previousInstance as NettingOpinionInstance | null}
                    opinion={opinion}
                    isEditing={isEditing}
                    isUpdating={isUpdating}
                    width={width}
                    nettingEngineFields={nettingEngineFields}
                />;
            case OpinionInstanceType.CLIENT_RELIANCE:
                return <ClientRelianceInstance
                    instance={instance}
                    previousInstance={previousInstance as ClientRelianceOpinionInstance | null}
                    opinion={opinion}
                    isEditing={isEditing}
                    isUpdating={isUpdating}
                    width={width}
                    nettingEngineFields={nettingEngineFields}
                />;
            case OpinionInstanceType.COLLATERAL_PROVIDER:
                return <CollateralProviderInstance
                    instance={instance}
                    previousInstance={previousInstance as CollateralProviderOpinionInstance | null}
                    opinion={opinion}
                    isEditing={isEditing}
                    isUpdating={isUpdating}
                    width={width}
                    nettingEngineFields={nettingEngineFields}
                />;
            case OpinionInstanceType.COLLATERAL_TAKER:
                return <CollateralTakerInstance
                    instance={instance}
                    previousInstance={previousInstance as CollateralTakerOpinionInstance | null}
                    opinion={opinion}
                    isEditing={isEditing}
                    isUpdating={isUpdating}
                    width={width}
                    nettingEngineFields={nettingEngineFields}
                />;
            case OpinionInstanceType.REPO:
                return <RepoInstance
                    instance={instance}
                    previousInstance={previousInstance as RepoOpinionInstance | null}
                    opinion={opinion}
                    isEditing={isEditing}
                    isUpdating={isUpdating}
                    width={width}
                    nettingEngineFields={nettingEngineFields}
                />;
            case OpinionInstanceType.STOCK_LENDING:
                return <StockLendingInstance
                    instance={instance}
                    previousInstance={previousInstance as StockLendingOpinionInstance | null}
                    opinion={opinion}
                    isEditing={isEditing}
                    isUpdating={isUpdating}
                    width={width}
                    nettingEngineFields={nettingEngineFields}
                />;
            case OpinionInstanceType.REPO_STOCK_LENDING:
                return <RepoStockLendingInstance
                    instance={instance}
                    previousInstance={previousInstance as RepoStockLendingOpinionInstance | null}
                    opinion={opinion}
                    isEditing={isEditing}
                    isUpdating={isUpdating}
                    width={width}
                    nettingEngineFields={nettingEngineFields}
                />;
            default:
                return null;
        }
    }, [instance, opinion, isEditing, isUpdating, width, nettingEngineFields, previousInstance]);

    return (
        <div className={styles.instanceWrapper}>
            {component}
        </div>
    );
};
